import React from 'react';
import { TrendingUpIcon, GlobeIcon, AwardIcon, ZapIcon } from 'lucide-react';
export function WhyNow() {
  return <section className="py-24" data-id="element-406">
      <div className="max-w-7xl mx-auto px-6" data-id="element-407">
        <div className="text-center mb-16" data-id="element-408">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-409">
            Why AI Leadership, Why Now?
          </h2>
          <p className="text-xl text-slate-400 max-w-3xl mx-auto" data-id="element-410">
            The gap between AI capability and leadership readiness is widening
            every day
          </p>
        </div>

        {/* Pain points */}
        <div className="grid md:grid-cols-3 gap-6 mb-16" data-id="element-411">
          <div className="bg-slate-800/30 border border-slate-700/50 rounded-lg p-6" data-id="element-412">
            <TrendingUpIcon className="w-8 h-8 text-red-400 mb-4" data-id="element-413" />
            <h3 className="text-lg font-semibold text-white mb-2" data-id="element-414">
              AI is Moving Faster Than Leadership Comfort
            </h3>
            <p className="text-slate-400" data-id="element-415">
              New models, tools, and capabilities emerge weekly. Leaders feel
              behind before they even start.
            </p>
          </div>

          <div className="bg-slate-800/30 border border-slate-700/50 rounded-lg p-6" data-id="element-416">
            <ZapIcon className="w-8 h-8 text-yellow-400 mb-4" data-id="element-417" />
            <h3 className="text-lg font-semibold text-white mb-2" data-id="element-418">
              Dabbling Without Strategy
            </h3>
            <p className="text-slate-400" data-id="element-419">
              Teams experiment with ChatGPT, but lack workflow OS, governance,
              and a real transformation plan.
            </p>
          </div>

          <div className="bg-slate-800/30 border border-slate-700/50 rounded-lg p-6" data-id="element-420">
            <AwardIcon className="w-8 h-8 text-purple-400 mb-4" data-id="element-421" />
            <h3 className="text-lg font-semibold text-white mb-2" data-id="element-422">
              FOMO and Confusion Simultaneously
            </h3>
            <p className="text-slate-400" data-id="element-423">
              Everyone knows AI matters. Few know where to start, what to
              prioritize, or how to lead through it.
            </p>
          </div>
        </div>

        {/* Our differentiators */}
        <div className="bg-gradient-to-br from-slate-800/50 to-slate-900/50 border border-slate-700 rounded-2xl p-12" data-id="element-424">
          <h3 className="text-3xl font-bold text-white mb-8 text-center" data-id="element-425">
            Why DestaMeet AI Leadership Hyper-Accelerator
          </h3>

          <div className="grid md:grid-cols-2 gap-8 mb-8" data-id="element-426">
            <div className="flex gap-4" data-id="element-427">
              <div className="w-12 h-12 bg-cyan-500/20 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-428">
                <GlobeIcon className="w-6 h-6 text-cyan-400" data-id="element-429" />
              </div>
              <div data-id="element-430">
                <h4 className="text-xl font-semibold text-white mb-2" data-id="element-431">
                  Global Track Record
                </h4>
                <p className="text-slate-400" data-id="element-432">
                  Thousands of innovation and entrepreneurship programs
                  delivered globally. We've trained leaders across continents
                  and industries.
                </p>
              </div>
            </div>

            <div className="flex gap-4" data-id="element-433">
              <div className="w-12 h-12 bg-purple-500/20 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-434">
                <AwardIcon className="w-6 h-6 text-purple-400" data-id="element-435" />
              </div>
              <div data-id="element-436">
                <h4 className="text-xl font-semibold text-white mb-2" data-id="element-437">
                  Practitioner-Professors
                </h4>
                <p className="text-slate-400" data-id="element-438">
                  Faculty who teach at Stanford, Wharton, INSEAD, MIT, and
                  Ivey—and who also ship real AI products and advise leading
                  companies.
                </p>
              </div>
            </div>

            <div className="flex gap-4" data-id="element-439">
              <div className="w-12 h-12 bg-cyan-500/20 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-440">
                <ZapIcon className="w-6 h-6 text-cyan-400" data-id="element-441" />
              </div>
              <div data-id="element-442">
                <h4 className="text-xl font-semibold text-white mb-2" data-id="element-443">
                  Direct AI Lab Access
                </h4>
                <p className="text-slate-400" data-id="element-444">
                  Team members who have worked with Dr. Geoffrey Hinton and
                  leading AI labs. Direct partnerships with OpenAI, Claude,
                  Perplexity, and more.
                </p>
              </div>
            </div>

            <div className="flex gap-4" data-id="element-445">
              <div className="w-12 h-12 bg-purple-500/20 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-446">
                <GlobeIcon className="w-6 h-6 text-purple-400" data-id="element-447" />
              </div>
              <div data-id="element-448">
                <h4 className="text-xl font-semibold text-white mb-2" data-id="element-449">
                  Singapore Innovation Hub
                </h4>
                <p className="text-slate-400" data-id="element-450">
                  Based in Singapore, the world's innovation hub. Delivered in
                  world-class destinations through exclusive partnership with
                  DestaMeet.
                </p>
              </div>
            </div>
          </div>

          <div className="border-t border-slate-700 pt-8" data-id="element-451">
            <p className="text-xl text-white font-semibold text-center mb-4" data-id="element-452">
              This is not another webinar.
            </p>
            <p className="text-slate-400 text-center max-w-3xl mx-auto" data-id="element-453">
              This is a 48-hour, in-person, contact-intensive experience where
              you build real prototypes, make real commitments, and leave with a
              real plan you can execute Monday morning.
            </p>
          </div>
        </div>
      </div>
    </section>;
}